import { record } from '@root/src/web/browser/ophan/ophan';
const recordMessageTimeoutInOphan = (messageId, slotName) => record({
    component: `${slotName}-picker-timeout-dcr`,
    value: messageId,
});
const timeoutify = (candidateConfig, slotName) => {
    let timer;
    const canShow = () => new Promise((resolve) => {
        if (candidateConfig.timeoutMillis) {
            timer = window.setTimeout(() => {
                recordMessageTimeoutInOphan(candidateConfig.candidate.id, slotName);
                resolve({ show: false });
            }, candidateConfig.timeoutMillis);
        }
        candidateConfig.candidate
            .canShow()
            .then((result) => resolve(result))
            .catch((e) => console.error(`timeoutify candidate - error: ${e}`));
    });
    const cancelTimeout = () => timer && clearTimeout(timer);
    return {
        ...candidateConfig,
        candidate: {
            ...candidateConfig.candidate,
            canShow,
        },
        cancelTimeout,
    };
};
const clearAllTimeouts = (messages) => messages.map((m) => m.cancelTimeout());
const defaultShow = () => null;
export const pickMessage = ({ candidates, name, }) => new Promise((resolve) => {
    const candidateConfigsWithTimeout = candidates.map((c) => timeoutify(c, name));
    const results = candidateConfigsWithTimeout.map((candidateConfig) => ({
        candidateConfig,
        canShow: candidateConfig.candidate.canShow(),
    }));
    const winnerResult = results.reduce(async (winningMessageSoFar, { candidateConfig, canShow }) => {
        if (await winningMessageSoFar) {
            return winningMessageSoFar;
        }
        const result = await canShow;
        candidateConfig.cancelTimeout();
        if (result.show) {
            return {
                candidate: candidateConfig.candidate,
                meta: result.meta,
            };
        }
        return winningMessageSoFar;
    }, Promise.resolve(null));
    winnerResult
        .then((winner) => {
        clearAllTimeouts(candidateConfigsWithTimeout);
        if (winner === null) {
            resolve(defaultShow);
        }
        else {
            const { candidate, meta } = winner;
            resolve(() => candidate.show(meta));
        }
    })
        .catch((e) => console.error(`pickMessage winner - error: ${e}`));
});
